import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import emailjs from 'emailjs-com';

@Injectable({
  providedIn: 'root'
})
export class LandingService {

  constructor() { }

  sendContact(data: any): Promise<string> {
    console.log(data);
  
    return emailjs.send("service_e1c81mm", "template_g6rnc57", {
      to_email: "said.satour@gmail.com",
      to_name: "MasterField Support",
      from_name: data.name,
      from_email: data.email,
      phone: data.phone,
      structure: data.structure,
      subject: data.object,
      message: data.message,
    }, "_WlYKCii1IoAUgO90")
    .then(response => {
      console.log('Email envoyé !', response);
      return "sent";  
    })
    .catch(error => {
      console.error('Erreur:', error);
      return "not_sent"; 
    });
  }
  
  noDisposableEmail(): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) return null;
  
      const emailParts = control.value.split('@');
      if (emailParts.length !== 2) return { invalidEmail: true };
  
      const domain = emailParts[1].toLowerCase();
      const disposableDomains = [
        'yopmail.com', 'mailinator.com', 'tempmail.com', 'guerrillamail.com', '10minutemail.com',
        'maildrop.cc', 'sharklasers.com', 'throwawaymail.com', 'getnada.com', 'temp-mail.org'
      ];
  
      return disposableDomains.includes(domain) ? { disposableEmail: true } : null;
    };
  }
}